/* eslint-disable react/jsx-props-no-spreading -- wrappers here forward props wholesale */
import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { HeadingContext } from './Section';

const Module = styled.div`
  ${({ gutterless }) =>
    !gutterless &&
    css`
      padding: 0 ${Board.Gutter.Desktop}px;
      @media (${UI.Viewport.to.Desktop}) {
        padding: 0 ${Board.Gutter.Tablet}px;
      }
      @media (${UI.Viewport.to.Tablet}) {
        padding: 0 ${Board.Gutter.Mobile}px;
      }
    `}
`;

export default ({
  selectable = true,
  prior,
  selector,
  onClick,
  children,
  gapless = false,
  tag = 'div',
  styles,
  ...props
}) => {
  const { moduleType } = Board.build;
  const Tag = tag;

  let backgroundClass = null
  if (_.get(Board.Value.contents, selector?.split('/'))?.type === 'CardSet') {
    if (_.get(Board.Value, Board.Path.concat('settings', 'backgroundColor')) === 'black') {
      backgroundClass = 'background-black'
    }
  }

  return (
    <HeadingContext.Consumer>
      {({ headingLevel } = {}) => {
        const gaplessProp = (!!headingLevel && !prior) || gapless;
        const baseClassName = 'pb-module-container';
        const gaplessClassName = `${baseClassName}-${gaplessProp ? 'gapless' : 'gapped'}`;
        return (
          <Tag
            className={`${baseClassName} ${gaplessClassName} ${gaplessClassName}-${moduleType} ${backgroundClass}`}
            css={styles}
          >
            <UI.Selection selectable={selectable} unwrapped={!selectable} onClick={onClick} selector={selector}>
              <Module {...props}>{children}</Module>
            </UI.Selection>
          </Tag>
        );
      }}
    </HeadingContext.Consumer>
  );
};
